import {gql} from "@irati/utils/gql"
import getQueryNames from "../../../services/apollo/helpers/getQueryNames"

export const intercomJwtQuery = gql`
  query GenerateIntercomJwt($channel: ThirdPartyTokenChannel!) {
    generateIntercomJwt(channel: $channel)
  }
`

export const intercomJwtKey = getQueryNames(intercomJwtQuery)[0]
